import { useState } from 'react';
import { useConfiguratorStore } from '../store';
import { useDesignStore } from '../store/design/context';

const useBundleDrawer = () => {
  // CODE SMELL: if not a custom hook maybe name handleBundleDrawer ??
  const [bundleId, setBundleId] = useState(null);
  const bundles = useDesignStore((state) => state.bundles.data);
  const drawer = useConfiguratorStore((state) => state.drawer);
  const updateDrawer = useConfiguratorStore((state) => state.updateDrawer);

  const openDrawer = () => {
    updateDrawer({ ...drawer, isOpen: true });
  };

  const closeDrawer = () => {
    updateDrawer({ bundleId: null, isOpen: false });
  };

  const setBundle = (id) => {
    updateDrawer({ bundleId: id, isOpen: true });
  };

  const bundle = bundles?.[drawer?.bundleId] ?? {};

  return {
    isOpen: drawer?.isOpen, openDrawer, closeDrawer, setBundle, bundle
  };
};

export default useBundleDrawer;
